import { render, staticRenderFns } from "./oddFormRegion.vue?vue&type=template&id=0a277d8b&scoped=true&"
import script from "./oddFormRegion.vue?vue&type=script&lang=js&"
export * from "./oddFormRegion.vue?vue&type=script&lang=js&"
import style0 from "./oddFormRegion.vue?vue&type=style&index=0&id=0a277d8b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a277d8b",
  null
  
)

export default component.exports